/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React,{useState,useEffect,useContext} from 'react'
import ReactModal from 'react-modal';
import Modal from 'react-modal'
import { CDN, exceptThisSymbols } from '../../constants';
import ClearCart from '../../Pages/OfferDetails/ClearCart';
import { WishlistExist } from '../../redux/helper/AddWishlist';
import { CartPayload } from '../../redux/helper/CartPayloadGenerator';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../Context/HeaderContext';
import WishlistContext from '../Context/WishlistContext';
import ThreeDotsLoader from '../LoadingDots';

export default function AddToCart({product,isClose,handlefetch,Cart}) {
    const [quantity, setquantity] = useState();
    const [removePopup, setremovePopup] = useState('');
    const [removeLoader, setremoveLoader] = useState(false);
    const handleProductCount=()=>{
        let count=(product?.MINIMUM_ORDER_QUANTITY ||1) < (product?.PACKING_SIZE || 1)? (product?.PACKING_SIZE ||1) : (product?.MINIMUM_ORDER_QUANTITY ||1);
        return count;
    }
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setquantity(handleProductCount())
    }, [product])
    
    const [quantityError, setquantityError] = useState(false);
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
     
    const handleErrorMessage = (message)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        isClose('')
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
            setloading(false)

        }, 1000);
    }
    const handleSuccessMessage = (message)=>{
        SetSuccessMessage(message);
        // handlefetch()
        setTimeout(() => {
            SetSuccessMessage('');
            isClose({});
            setcolorValue(false);
            setloading(false)
        },1000)
    }
    const haddleError = () =>{
        if(Math.round(quantity * 10000) % Math.round((product?.PACKING_SIZE|| 1) * 10000) !==0){
            setquantityError(true);
        }
        else{
            setquantityError(false);
        }
    }
    const handleConfirm = async()=>{
        setloading(true)
        const payload=CartPayload(product,quantity)
        const res = await distributorService.AddToCart(payload);
        if(!res.error && res.data.success_status){
            handleSuccessMessage(res.data.message)
        }else{
            if(res?.message?.response?.data?.special_offer_exist){
                setremovePopup('active');
                SetErrorMessage(res?.message?.response?.data?.message ||'Something went wrong');
                setcolorValue(true);
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(false);
                    setloading(false)
                }, 1000);
            }else{
                handleErrorMessage(res?.message?.response?.data?.message);

            }
        }
    }
    

    
    function nearest(n, x) {
        const u = n % x >= x / 2;
        return n + (-1) ** (1 - u) * Math.abs(x * u - n % x);
    }
    const handleQuantity = (type, quantity) => {
        let copy = Number(quantity);
        if (type === '+') {
            if(copy < Number(handleProductCount(product))){
                copy= handleProductCount(product)
                setquantity(copy);
                return     
            }
            if (Math.round(parseFloat(copy) * 10000) % Math.round(parseFloat(product.PACKING_SIZE ||1) * 10000) !==0) {
                copy = nearest(copy, (Number(product?.PACKING_SIZE) || 1));
            } else copy += Number(product?.PACKING_SIZE) || 1;
            setquantity(Number(copy).toFixed(2));
        }
        if (type === '-') {
            if (copy - product.PACKING_SIZE >= product?.MINIMUM_ORDER_QUANTITY) {
                if (Math.round(parseFloat(copy) * 10000) % Math.round(parseFloat(product.PACKING_SIZE ||1) * 10000) !==0) {
                    copy = nearest(copy, (Number(product?.PACKING_SIZE) || 1));
                } else copy -= Number(product?.PACKING_SIZE) || 1;
            }
            setquantity(Number(copy).toFixed(2));
        }
        handleCheck(copy);
    }
    
    const handleCheck = (copy) => {
        setquantityError(false);
        if (copy < Number(product?.MINIMUM_ORDER_QUANTITY) || (Math.round(copy * 10000) % Math.round((product?.PACKING_SIZE || 1) * 10000) !== 0)) {
            setquantityError(true);
        }
    };
    const handleClearCart=async()=>{
        const cart = await distributorService.clearCart();
        if(!cart.error && cart.data.success_status){
            setremovePopup('');
            handlefetch()
        
        }
    }
    const handleImage = (img)=> img?`${CDN}/product-images/${img}`:'/images/gen.png';
    return (
        <>
            <ReactModal style={{overFlow:'auto'}} isOpen={removePopup!==''}>
                <ClearCart
                    // RemoveFromCart={RemoveFromCart}
                    setremovePopup={setremovePopup}
                    handleClearCart={handleClearCart}
                    handleAddBulkProducts={handleConfirm}
                    loading={removeLoader}
                    setremoveLoader={setremoveLoader}/>
            </ReactModal>
            <Modal
                style={{overFlow:'auto'}}
                isOpen={Object.keys(product).length >0 && removePopup===''}>
                <div className={`modal fade fixed top-0 left-0 ${removePopup !== '' ? 'hidden' : 'show'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="addtocart" tabIndex="-1" aria-labelledby="addtocart" aria-modal="true" role="dialog">
                    <div className="modal-dialog modal-dialog-centered relative pointer-events-none sm:max-w-[444px] w-auto px-2" style={{ margin:"auto" }}>
                        <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                            <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md px-10">
                                <h5 className="sm:text-lg text-base font-semibold text-[#090406] text-center w-full border-b border-[#707070] lg:pb-[18px] pb-3.5" id="exampleModalScrollableLabel1">
                                    Add to Cart
                                </h5>
                                <button type="button"
                                    onClick={()=>{
                                        isClose({});
                                        setquantityError(false)

                                    }}
                                    className="btn-close1 box-content sm:w-4 sm:h-4 w-3 h-3 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute sm:top-[22px] sm:right-5 top-4 right-4"
                                    data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body relative px-10 pt-[18px] text-center">
                                <div className={`flex justify-center`}>
                                    <img src={handleImage(product?.IMAGE_NAME)} alt="icon" style={{height:'104px',width:'137px',objetFit:'cover'}}/>
                                </div>
                                <p className="lg:text-xs4 md:text-lg text-base font-bold text-[#090406] text-center lg:pt-3.5 pt-1">{product?.MODEL_DESCRIPTION || `${product?.DESCRIPTION?.length > 20 ? `${product.DESCRIPTION.slice(0,20)}...`:`${product.DESCRIPTION}`}`}</p>
                                <p className="text-xs font-normal text-[#808285] pt-0.5">Product Code: {product.CONCATENATED_SEGMENTS} {product.AWS_CLASSIFICATION === null ? null : `| AWS Classification: ${product.AWS_CLASSIFICATION}`}</p>
                            </div>
                            <div className="pt-4">
                                <p className="text-xs6 font-semibold text-[#808285] text-center">Set Quantity</p>
                                <div className={`flex justify-center pt-2 items-center`}>
                                    <img src="/images/Group8502.png" alt="icon" className={`${quantity>1?'cursor-pointer':'pointer-events-none'}`} onClick={()=>handleQuantity('-', quantity)}/>
                                    <input value={quantity} 
                                        type="text"
                                        pattern="\d.*"
                                        onChange={(e)=>{
                                            setquantity(e.target.value);
                                            handleCheck(e.target.value)}}
                                        maxLength="11"
                                        onKeyUp={haddleError}
                                        onKeyDown={(e) => ['e', 'E', '+', '-',].includes(e.key) && e.preventDefault()}
                                        className="sm:w-[110px] w-13 h-7 border border-[#808285] rounded-lg outline-0 text-center sm:px-2 px-1 sm:text-xs9 text-xs6 font-semibold text-[#090406] mx-2" />
                                    <p className="text-base font-semibold text-[#090406] self-end mr-2">{product?.PRIMARY_UOM_CODE}</p>
                                    <img src="/images/Group8503.png" alt="icon" className='cursor-pointer' onClick={()=>handleQuantity('+', quantity)}/>
                                </div>
                                <>{quantityError && <p className="text-xs3 font-normal text-[#ED1C24] pt-2 flex justify-center items-center">
                                    <span>
                                        <img src="/images/info_icon.svg" alt="icon" className="cursor-pointer pr-1"/>
                                    </span>
                                    Quantity should be based on the MOQ and Standard Pack Size
                                </p>}</>
                                <div className="md:px-16 sm:px-10 px-5 lg:pt-[22px] pt-3">
                                    <div className="flex items-center justify-between">
                                        <p className="lg:text-xl sm:text-base text-sm font-semibold text-[#808285] pr-1">List Price</p>
                                        <p className="lg:text-xs11 sm:text-lg text-base font-semibold text-[#15090E]">{Number(product?.LIST_PRICE).toLocaleString('en-IN', {
                                            style: 'currency',
                                            currency: 'INR',
                                        })}</p>
                                    </div>
                                    <div className="flex items-center justify-between md:pt-2 pt-1">
                                        <p className="lg:text-xl sm:text-base text-sm font-semibold text-[#808285] pr-1">Amount</p>
                                        <p className="lg:text-xs11 sm:text-lg text-base font-semibold text-[#15090E]">{(product?.LIST_PRICE*quantity).toLocaleString('en-IN', {
                                            style: 'currency',
                                            currency: 'INR',
                                        })}</p>
                                    </div>
                                </div>
                                <div className="flex justify-center sm:pt-[33px] pt-6 pb-[18px]">
                                    <button type="buton"
                                        onClick={()=>{
                                            handleConfirm()
                                        }}
                                        disabled={quantityError ||quantity<=0}
                                        className="bg-[#555259] flex justify-center items-center rounded-lg md:w-[284px] w-[200px] md:h-10 h-8 text-sm font-semibold text-[#FFFFFF] cart-add"
                                        data-bs-dismiss="modal" aria-label="Close">
                                        <>{ loading?<ThreeDotsLoader/>:'Confirm'}</>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}